import type { LocationSchema } from '@libs/data-access/entities'

export const isContractEligibleForModulation = (
  data: LocationSchema[],
  newLocationId: number,
  newTeamId: number
) => {
  const location = data?.find(location => location.id === newLocationId)

  // check if default team was selected from a location with more than one team
  if (!newTeamId && location?.teams.length !== 1) {
    return false
  }

  // newTeamId is 0 for locations with only one team
  const team = newTeamId
    ? location?.teams.find(team => team.id === newTeamId)
    : location?.teams[0]

  const isContractEligibleForModulation = Boolean(
    team?.current_and_future_modulation_location_contracts
  )

  return isContractEligibleForModulation
}
